module.exports = __webpack_public_path__ + "img/hryvna-orange-circle.dad47b41.svg";